// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
}

input {
    background-color: #ddd;
    border: none;
}

#input-wrapper {
    font-family: Consolas, monaco, monospace;
    text-align: center;
    width: 50%;
    margin: 0 auto;
}

#input-wrapper #input {
    width: 100%;
    height: 25px;
    text-align: center;
}

#input-wrapper #disclaimer {
    text-align: left;
    float: left;
    font-style: italic;
    font-size: 12px;
    opacity: 0.6;
    max-width: 70%;
}

#input-wrapper #links {
    text-align: right;
    float: right;
    max-width: 20%;
}

#home-button {
    position: absolute;
    top: 8px;
    left: 8px;
    text-decoration: none;
    font-size: 25px;
}

#example-links > * {
    white-space: nowrap;
}

/********/

#dark-toggle {
    position: absolute;
    top: 8px;
    right: 8px;
    text-decoration: none;
    font-size: 25px;
}

body.dark {
    background-color: #222;
    color: #ddd;
}

.dark input {
    background-color: #444;
    color: #ccc;
}

.dark a {
    color: rgb(147, 43, 243);
}

/* https://github.com/swagger-api/swagger-ui/issues/5327#issuecomment-742375520 */
.dark .swagger-ui {
    filter: invert(88%) hue-rotate(180deg);
}

.dark .swagger-ui .highlight-code {
    filter: invert(100%) hue-rotate(180deg);
}

/* overrides */
.swagger-ui .opblock .opblock-summary-path {
    max-width: 100% !important;
}

.responses-inner, .model-container {
    overflow-y: auto !important;
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;AACA;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,wCAAwC;IACxC,kBAAkB;IAClB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,SAAS;;AAET;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,iFAAiF;AACjF;IACI,sCAAsC;AAC1C;;AAEA;IACI,uCAAuC;AAC3C;;AAEA,cAAc;AACd;IACI,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":["body {\n}\n\ninput {\n    background-color: #ddd;\n    border: none;\n}\n\n#input-wrapper {\n    font-family: Consolas, monaco, monospace;\n    text-align: center;\n    width: 50%;\n    margin: 0 auto;\n}\n\n#input-wrapper #input {\n    width: 100%;\n    height: 25px;\n    text-align: center;\n}\n\n#input-wrapper #disclaimer {\n    text-align: left;\n    float: left;\n    font-style: italic;\n    font-size: 12px;\n    opacity: 0.6;\n    max-width: 70%;\n}\n\n#input-wrapper #links {\n    text-align: right;\n    float: right;\n    max-width: 20%;\n}\n\n#home-button {\n    position: absolute;\n    top: 8px;\n    left: 8px;\n    text-decoration: none;\n    font-size: 25px;\n}\n\n#example-links > * {\n    white-space: nowrap;\n}\n\n/********/\n\n#dark-toggle {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    text-decoration: none;\n    font-size: 25px;\n}\n\nbody.dark {\n    background-color: #222;\n    color: #ddd;\n}\n\n.dark input {\n    background-color: #444;\n    color: #ccc;\n}\n\n.dark a {\n    color: rgb(147, 43, 243);\n}\n\n/* https://github.com/swagger-api/swagger-ui/issues/5327#issuecomment-742375520 */\n.dark .swagger-ui {\n    filter: invert(88%) hue-rotate(180deg);\n}\n\n.dark .swagger-ui .highlight-code {\n    filter: invert(100%) hue-rotate(180deg);\n}\n\n/* overrides */\n.swagger-ui .opblock .opblock-summary-path {\n    max-width: 100% !important;\n}\n\n.responses-inner, .model-container {\n    overflow-y: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
